<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import NavbarMobile from './NavbarMobile.vue'
import NavbarDesktop from './NavbarDesktop.vue'
import { useCarteleraStore } from '@/store/carteleraStore'
import { storeToRefs } from 'pinia'
import { useUsuarioStore } from '@/store/usuarioStore'
// mismo breakpoint (<= 991px es mobile)
const QUERY = '(max-width: 991px)'
const isMobile = ref(false)
const usuarioStore = useUsuarioStore()
const cartelera = useCarteleraStore()
const { categoriasLotes } = storeToRefs(cartelera)

let mm

const update = () => (isMobile.value = mm.matches)

onMounted(async () => {
  mm = window.matchMedia(QUERY)
  update()
  mm.addEventListener ? mm.addEventListener('change', update)
                      : mm.addListener(update)

  await cartelera.obtenerCategoriasLotes();
})
onBeforeUnmount(() => {
  mm && (mm.removeEventListener ? mm.removeEventListener('change', update)
    : mm.removeListener(update))
})
</script>

<template>
  
  <div class="mb-0 mb-lg-2">
    <NavbarMobile v-if="isMobile" :categoriasLotes="categoriasLotes" :usuarioStore="usuarioStore" />
    <NavbarDesktop class="margen-bottom" v-else :categoriasLotes="categoriasLotes" :usuarioStore="usuarioStore" />
  </div>
    <main class="contenido-layout">
    </main>
</template>

<style scoped>


@media (min-width: 992px) {
  .contenido-layout {
    padding-top: 100px;
  }
}

</style>